import React from 'react';
import { Link } from 'react-router-dom';
import { servicesData } from '../data/mock';

const Services = () => {
  const modularFacilities = [
    'Modular Operation Theatre',
    'Modular MICU',
    'Modular SICU',
    'Modular Cardiac ICU',
    'Modular Neuro ICU',
    'Modular PICU',
    'Modular NICU',
    'Modular Trauma ICU',
    'Modular Burns ICU',
    'Modular Transplant ICU',
    'Modular TB ICU',
    'Modular Radiology Centre',
    'Modular Cath Lab',
    'Modular HDU',
    'Modular Mortuary'
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container text-center">
          <h1 className="hero-large mb-6">Comprehensive Healthcare Solutions</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Modular turnkey solutions in EPC mode covering design, engineering, statutory approvals, procurement, construction, supply, installation, testing, validation, commissioning, and long-term operations.
          </p>
        </div>
      </section>

      {/* Main Services */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid-product-showcase">
            {servicesData.map((service) => (
              <div key={service.id} className="product-card">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="product-card-image"
                />
                <h3 className="product-card-title">{service.title}</h3>
                <p className="product-card-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Service Breakdown */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="hero-medium mb-12 text-center">End-to-End Service Portfolio</h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Column */}
            <div className="space-y-8">
              <div>
                <h3 className="heading-2 mb-4">Conceptual Planning & Design</h3>
                <ul className="space-y-2">
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Site analysis and feasibility studies</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• ROI assessment and financial planning</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Detailed Project Report (DPR) preparation</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Architectural design as per NMC, NABH, ICMR standards</li>
                </ul>
              </div>

              <div>
                <h3 className="heading-2 mb-4">Engineering & Procurement</h3>
                <ul className="space-y-2">
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• MEP (Mechanical, Electrical, Plumbing) systems</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Modular healthcare infrastructure</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Medical gas pipeline systems</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• HVAC and cleanroom solutions</li>
                </ul>
              </div>

              <div>
                <h3 className="heading-2 mb-4">Medical Equipment & IT Systems</h3>
                <ul className="space-y-2">
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Complete medical equipment planning</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Procurement and installation</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Hospital Information Management Systems (HIMS)</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Patient report management systems</li>
                </ul>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-8">
              <div>
                <h3 className="heading-2 mb-4">Construction & Installation</h3>
                <ul className="space-y-2">
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Complete civil and structural works</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Modular cleanroom construction</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Specialized medical facility setup</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Quality control and safety compliance</li>
                </ul>
              </div>

              <div>
                <h3 className="heading-2 mb-4">Testing & Commissioning</h3>
                <ul className="space-y-2">
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Comprehensive testing and validation</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Statutory approvals and certifications</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Performance verification</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Final handover with documentation</li>
                </ul>
              </div>

              <div>
                <h3 className="heading-2 mb-4">Operations & Management</h3>
                <ul className="space-y-2">
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Complete hospital staffing solutions</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Medical, paramedical, and technical staff</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Administrative and facility management</li>
                  <li className="body-regular" style={{ color: 'var(--text-secondary)' }}>• Long-term operational excellence</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modular Facilities */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="hero-medium mb-4">Modular Healthcare Infrastructure</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
              Specialized modular facilities designed, engineered, and constructed to international standards
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {modularFacilities.map((facility, index) => (
              <div 
                key={index}
                style={{
                  background: 'var(--bg-primary)',
                  padding: '24px',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)'
                }}
              >
                <p className="body-large" style={{ color: 'var(--text-primary)' }}>
                  {facility}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding cta-section-dark">
        <div className="container text-center">
          <h2 className="hero-medium mb-4 cta-heading-light">
            Ready to Build World-Class Healthcare Infrastructure?
          </h2>
          <p className="body-large mb-8 cta-text-light">
            Discuss your project requirements with our expert team.
          </p>
          <Link 
            to="/contact" 
            className="btn-primary btn-light-on-dark"
          >
            Request Project Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
